import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import PublicNavbar from "../components/PublicNavbar";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    if (bookingId) {
      fetchBooking();
    }
  }, [bookingId]);

  const fetchBooking = async () => {
    try {
      const response = await fetch(`${API}/booking/${bookingId}`);
      if (response.ok) {
        setBooking(await response.json());
      }
    } catch {
      // Silent fail - booking info is optional
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] relative overflow-hidden">
      <PublicNavbar />

      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#22C55E]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#D4AF37]/3 rounded-full blur-3xl"></div>
      </div>

      <main className="relative z-10 pt-32 pb-20 px-6 flex items-center justify-center min-h-[calc(100vh-80px)]">
        <div className="max-w-md w-full text-center">
          <div className="w-20 h-20 rounded-full bg-[#22C55E]/20 flex items-center justify-center mx-auto mb-6">
            <CheckCircle size={48} className="text-[#22C55E]" />
          </div>
          
          <h1 className="text-3xl font-bold text-[#FAFAFA] mb-4">
            Payment Successful!
          </h1>
          
          <p className="text-[#A1A1AA] mb-8">
            Thank you for your booking. A confirmation email has been sent to your inbox.
          </p>

          {booking && (
            <div className="bg-[#121214] border border-[#27272A] rounded-xl p-6 mb-8 text-left">
              <h3 className="text-lg font-semibold text-[#FAFAFA] mb-4">Booking Details</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-[#71717A]">Service</span>
                  <span className="text-[#FAFAFA]">{booking.service_name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#71717A]">Date</span>
                  <span className="text-[#FAFAFA]">{booking.date}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#71717A]">Time</span>
                  <span className="text-[#FAFAFA]">{booking.time}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#71717A]">Deposit Paid</span>
                  <span className="text-[#22C55E]">${booking.deposit_amount}</span>
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-col gap-3">
            <Link to="/">
              <Button className="w-full bg-gradient-to-r from-[#D4AF37] to-[#B8952F] text-[#0A0A0B]">
                Return Home
              </Button>
            </Link>
            <Link to="/booking">
              <Button variant="outline" className="w-full border-[#27272A] text-[#FAFAFA]">
                Book Another Session
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CheckoutSuccess;
